<template>
	<div class="myheader">
		<div class="header-content">
			<div class="logo"></div>
			<div class="nav1">产品介绍</div>
			<div class="nav2">招商合作</div>
			<div class="nav3">新闻资讯</div>
			<div class="nav4">关于我们</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'myheader',
	}
</script>

<style>
	.myheader{
		display: block;
		position: relative;
		/* width: 1920px; */
		width: 100%;
		height: 70px;
/* 		background-color: dimgrey;
		text-align: center; */
		
	}
	.header-content{
		/* background-color: darkgreen; */
		display: block;
		position: relative;
		width: 1920px;
		height: 70px;
		margin: 0 auto;
		background: #F0F0F0;
		box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.11);
	}
	.logo{
		display: inline-block;
		position: absolute;
		margin: 14px 1398px 13px 361px;
		width: 161px;
		height: 43px;
		background-image: url(../assets/logo.png);
	}
	.nav1{
		display: inline-block;
		position: absolute;
		margin: 27px 1141px 28px 710px;
		width: 69px;
		height: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #4F4F4F;
	}
	.nav2{
		display: inline-block;
		position: absolute;
		margin: 26px 992px 27px 858px;
		width: 70px;
		height: 17px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #4F4F4F;
	}
	.nav3{
		display: inline-block;
		position: absolute;
		margin: 26px 843px 27px 1007px;
		width: 70px;
		height: 17px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #4F4F4F;
	}
	.nav4{
		display: inline-block;
		position: absolute;
		margin: 27px 683px 28px 1168px;
		width: 69px;
		height: 15px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #4F4F4F;
	}
</style>
